import { useNavigate } from "react-router-dom";

import { faMailbox, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { InfoColumn, InfoColumnLabel, InfoColumnValue, InfoRow } from "components/atoms/InfoRow";
import useDateTime from "hooks/useDateTime";

import { User } from "generated/graphql-types";

export default function UserRow({ user }: { user: User }) {
	const date = useDateTime();
	const navigate = useNavigate();

	return (
		<InfoRow
			interactive
			onClick={() => {
				if (user?.userId) navigate("/users/" + user?.userId);
			}}
		>
			<InfoColumn title="Navn" width="60%">
				<InfoColumnLabel>{user?.name || <u>Åpen bruker {user?.nickname ? "(" + user.nickname + ")" : ""}</u>}</InfoColumnLabel>
			</InfoColumn>
			<InfoColumn title="Telefonnummer" width="15%">
				<InfoColumnValue>
					<FontAwesomeIcon icon={faPhone} /> {user?.mobileNumber || "―"}
				</InfoColumnValue>
			</InfoColumn>
			<InfoColumn title="E-post" width="10%">
				<InfoColumnValue>
					<FontAwesomeIcon icon={faMailbox} /> {user.emailAddress || "―"}

				</InfoColumnValue>
			</InfoColumn>
		</InfoRow>
	);
}
